// extracted by mini-css-extract-plugin
module.exports = {"ImageGallery":"ImageGallery_ImageGallery__DncjJ","figure":"ImageGallery_figure__1_5Vp","image":"ImageGallery_image__Qhog8"};